"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var paymentDisclaimerModalStyles = makeStyles_1.default(function (_a) {
    var typography = _a.typography;
    return ({
        root: {
            display: 'grid',
            fontFamily: typography.fontFamily,
            padding: '16px',
        },
    });
}, { name: 'Checkout4_PaymentDisclaimerModal' });
exports.default = paymentDisclaimerModalStyles;
